import React from "react";
import {
  Modal,
  View,
  TouchableOpacity,
  StyleSheet,
  ActivityIndicator,
  Platform,
  Pressable,
} from "react-native";
import { AppText } from "@/components/AppText";
import { FontFamilies } from "@/constants/Typography";

type Props = {
  visible: boolean;
  count: number;
  isProcessing?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const BatchProcessConfirmationModal: React.FC<Props> = ({
  visible,
  count,
  isProcessing = false,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onCancel}
    >
      <Pressable style={styles.overlay} onPress={onCancel}>
        <Pressable
          style={styles.modalContainer}
          onPress={(e) => e.stopPropagation()}
        >
          <AppText style={styles.title}>Process All Payouts</AppText>
          <AppText style={styles.message}>
            Are you sure you want to process {count} payouts? This action cannot
            be undone.
          </AppText>

          <View style={styles.buttonContainer}>
            <TouchableOpacity
              style={[styles.button, styles.cancelButton]}
              onPress={onCancel}
              disabled={isProcessing}
            >
              <AppText style={styles.cancelText}>Cancel</AppText>
            </TouchableOpacity>

            <TouchableOpacity
              style={[styles.button, styles.processButton]}
              onPress={onConfirm}
              disabled={isProcessing}
            >
              {isProcessing ? (
                <ActivityIndicator size="small" color="#FFFFFF" />
              ) : (
                <AppText style={styles.processText}>Process</AppText>
              )}
            </TouchableOpacity>
          </View>
        </Pressable>
      </Pressable>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    padding: 24,
    width: Platform.OS === "web" ? 400 : "90%",
    maxWidth: 400,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  title: {
    fontSize: 18,
    fontFamily: FontFamilies.Inter.SemiBold,
    color: "#111827",
    marginBottom: 12,
  },
  message: {
    fontSize: 14,
    fontFamily: FontFamilies.Inter.Regular,
    color: "#6B7280",
    lineHeight: 20,
    marginBottom: 24,
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 12,
  },
  button: {
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 8,
    minWidth: 80,
    alignItems: "center",
    justifyContent: "center",
  },
  cancelButton: {
    backgroundColor: "#F3F4F6",
  },
  processButton: {
    backgroundColor: "#0F9129",
  },
  cancelText: {
    fontSize: 14,
    fontFamily: FontFamilies.Inter.Medium,
    color: "#6B7280",
  },
  processText: {
    fontSize: 14,
    fontFamily: FontFamilies.Inter.Medium,
    color: "#FFFFFF",
  },
});

export default BatchProcessConfirmationModal;
